<template>
  <div class="tindexApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="list">
    <div style="height:12px"></div>
      <ul>
        <li>
          <div class="title">
            <el-image style="width: 20%; height: 70px;float:left;margin-left:12px" src="http://admin.4008005216.com//upload/20240312/71fca2537bc144588d6f297442c2bb71.jpg" fit="cover"></el-image>
            <div class="conTitle">
              <span>11111</span>
              <div class="price">门票<i><b>¥</b>12</i>起
              <font>营业时间：000000</font></div>
            </div>
          </div>
        </li>
      </ul>
      <div style="height:60px"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .tindexApp {
    background:#F1F2F5;
  }
  .tindexApp .list{
    display:block;
    overflow-y:auto;
    width:100%
  }
  .tindexApp .list ul{
    display:block;
    margin:0 auto;
    width:94%
  }
  .tindexApp .list ul li{
    display:block;
    width:100%;
    margin-bottom:12px;
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .tindexApp .list ul li .title{
    position:relative;
    width:100%;
  }
  .tindexApp .list ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .tindexApp .list ul li .title img{
    border-radius:6px;
  }
  .tindexApp .list ul li .title .conTitle{
    float:left;
    width:73%;
    margin-left:2%;
  }

</style>